import axios from 'axios';
import { APIbase } from './variables';


export const test = async (data) => {
    console.log(data)

    try {
        return await axios.post(APIbase + '/test', {
            data: data
        })
    }
    catch(error) {
        console.log("this is an error")

        return error.response
    }

}

export const APICall = async (APIEndPoint, parameters, headers) => {
    //console.log(APIEndPoint, parameters)
    try {
        return await axios.post(APIbase + APIEndPoint, {
            data: parameters
        },
        {
            headers
        }
    )
    }
    catch(error) {
        console.log("this is an error")

        return error.response
    }

}